import commonMessages from '@/lang/messages/common';
import { EnumScreenName, EventProperties } from '@calm/evexia-analytics';
import { useIsMobile } from '@rhg/hooks/use-is-mobile';
import { Box, Button } from '@rhg/libs/material';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { ctaFooterStyles, styleButtonGroup, styleFlexGrow } from '../styles';

interface AgeGenderFormActionProps {
    formId: string;
    primaryCtaLabel?: string;
    primaryCtaStartIcon?: ReactNode;
    secondaryCtaLabel?: string;
    showSecondaryCta?: boolean;
    isDisabled?: boolean;
    onCancel?: () => void;
    trackScreen?: EnumScreenName;
    trackProps?: EventProperties;
}

export const AgeGenderFormActions = ({
    showSecondaryCta,
    secondaryCtaLabel,
    primaryCtaLabel,
    primaryCtaStartIcon,
    onCancel,
    isDisabled,
    formId,
    trackScreen,
    trackProps,
}: AgeGenderFormActionProps) => {
    const { formatMessage } = useIntl();
    const isMobile = useIsMobile();

    return (
        <Box sx={ctaFooterStyles}>
            <Box sx={styleButtonGroup}>
                {showSecondaryCta && (
                    <Button
                        trackButton="Cancel"
                        trackScreen={trackScreen}
                        trackProps={trackProps}
                        variant="outlined"
                        sx={isMobile ? {} : styleFlexGrow}
                        onClick={onCancel}
                    >
                        {secondaryCtaLabel ??
                            formatMessage(commonMessages['common.cancel'])}
                    </Button>
                )}
                <Button
                    trackButton="SubmitAgeAndGender"
                    trackScreen={trackScreen}
                    trackProps={trackProps}
                    variant="contained"
                    sx={styleFlexGrow}
                    startIcon={primaryCtaStartIcon}
                    type="submit"
                    form={formId}
                    disabled={isDisabled}
                >
                    {primaryCtaLabel ??
                        formatMessage(commonMessages['common.submit'])}
                </Button>
            </Box>
        </Box>
    );
};
